import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository.ts";
import { App } from "antd";
import type { ArgsProps } from "antd/es/notification/interface";
import { observer } from "mobx-react";
import type { FC } from "react";
import { useEffect } from "react";

export const ToastManager: FC = observer(() => {
    const { notification } = App.useApp();

    // Autorun here is key
    // 1) Mobx cant track observables inside useEffects by default, you need to be explicit
    // 2) When dealing with reactions only based in observables changes, autorun itself
    // is able to track dependencies automatically, so we can leave useEffect dependencies array empty
    useEffect(() => {
        const sub = ToastManagerRepository.toast.subscribe((it) => {
            const messageItem: ArgsProps = {
                message: it.title,
                description: it.description,
                showProgress: true,
            };

            switch (it.type) {
                case "success":
                    notification.success(messageItem);
                    break;
                case "info":
                    notification.info(messageItem);
                    break;
                case "warning":
                    notification.warning(messageItem);
                    break;
                case "error":
                    notification.error(messageItem);
                    break;
                default:
                    break;
            }
        });

        return (): void => {
            sub.unsubscribe();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
});

ToastManager.displayName = "ToastManager";
